import { EVENTS } from 'common/domain/constants';

class LoansAmountSimulationErrorsController {
  constructor($scope) {
    'ngInject';
    this.scope = $scope;
    this.errorsSimulation = {};
  }

  $onInit() {
    this.scope.$watch(() => this.isClickOnSubmit, () => {
      if (this.isClickOnSubmit) {
        this.copyErrors();
      }
    });

    this.scope.$on(EVENTS.LOANS_AMOUNT_SIMULATION_REFRESH_ERRORS, () => {
      this.copyErrors();
    });
  }

  $onChanges(changes) {
    if (changes.errors) {
      this.copyErrors();
    }
  }

  copyErrors() {
    this.errorsSimulation = angular.copy(this.errors);
  }

  hasError() {
    const errorKeys = Object.keys(this.errorsSimulation);
    return errorKeys.some(key => this.errorsSimulation[key] === true);
  }
}

export default LoansAmountSimulationErrorsController;



// WEBPACK FOOTER //
// ./client/app/loans.module/components/loansAmountSimulation/loansAmountSimulationErrors/loansAmountSimulationErrors.controller.js